<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
        <div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Documento
                  </th>
                  <th class="text-left">
                    Estado
                  </th>
                  <th class="text-left">
                    Validado
                  </th>
                  <th class="text-left">
                    Acción
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(element, index) in documentos" :key="index" >
                  <td>{{ element.documento }}</td>
                  <td>
                    <strong v-if="element.entregado == true && element.validado == false" style="color:green">
                      Entregado
                    </strong>
                    
                    <strong v-else-if="element.entregado == false && element.validado == false" style="color:red">
                      Faltante
                    </strong>
                  </td>
                  <td>
                   
                    <strong v-if="element.entregado == true && element.validado == true" style="color:green">
                      Validado
                    </strong>
                   
                  </td>
                  <td class="accionDoc">
                    <div v-if="element.documentos.length > 0 && (element.validado == false)">
                      <v-btn-toggle 
                        v-for="(docElement, docIndex) in element.documentos" 
                        :key="docIndex"
                        rounded 
                        class="btnUpload"
                        >
                        <v-btn
                          color="rgba(0, 0, 0, .5)"
                          fab
                          x-small
                          dark
                          elevation="7"
                          :title="docTitle(docIndex)" 
                          width="100px">
                          <p class="documentTitle">{{ docTitle(docIndex) }} </p>
                        </v-btn>
                    
                        <v-btn
                          color="primary"
                          fab
                          x-small
                          dark
                          elevation="7"
                          v-on:click="examen = true"
                          v-bind:href="docElement.documento_imagen.imagen"
                          target="_blank"
                          title="Ver">
                          <v-icon color="white">mdi-eye</v-icon>
                        </v-btn>
                    
                        <v-btn
                          color="info"
                          fab
                          x-small
                          dark
                          elevation="7"
                          v-on:click="examen = true"
                          @click="uploadFile(docElement.documento_completo.IDF)"
                          title="Modificar">
                          <v-icon color="white">mdi-pencil</v-icon>
                        </v-btn>
                    
                        <v-btn
                          color="error"
                          fab
                          x-small
                          dark
                          elevation="7"
                          v-on:click="examen = true"
                          @click="deleteDocumento(docElement.documento_imagen.IDVReg)"
                          title="Eliminar">
                          <v-icon color="white">mdi-delete</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </div>

                    <div v-if="element.documentos.length < 2 && (element.validado == false) && element.id!=10">
                      <v-btn 
                        v-for="btnElement in docCount(element.documentos)"
                        :key="btnElement"
                        color="success"
                        fab
                        x-small
                        dark
                        elevation="7"
                        v-on:click="examen = true"
                        @click="uploadFile(element.documento_completo.IDF)"
                        title="Subir Documento"
                        class="btnUpload"
                        >
                        <v-icon color="white">
                          mdi-cloud-upload
                        </v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <!-- </v-row> -->
      <input id="file-upload" type="file"  v-on:change="addDocument()"  ref="fileInput" class="inputUpload" />
    </CardIeaAppMain>
  </div>
</template>

<style>
    .hideTr{
        display: none;
    }
</style>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Documento",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title:"Documentos faltantes",
    selected:'',
    documentos:[],  
  }),

  methods: {
    async uploadFile(tipo_documento_id) {
      this.selected = tipo_documento_id;     
      this.$refs.fileInput.click()   
    },

    docTitle(index){
      return "Documento " + (index+1);
    },

    docCount(docList){
      return 2 - docList.length;
    },

    async addDocument() {
      var formData = new FormData();
      formData.append('tipo_documento_id', this.selected);
      formData.append('image', this.$refs.fileInput.files[0]);

      let url = "alumno-documentos/upload";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.$refs.fileInput.value = null;
          this.loadDocumentos();
        });
    },

    async deleteDocumento(id) {
      if(confirm('¿Estas seguro de eliminar este documento?')){
        let url = "alumno-documentos/delete/" + id;
        await this.$API
          .post({
            url: url,
          }).then(() => {
            this.loadDocumentos();
          });
      }
    },
    async loadDocumentos() {
      let url = "documentos/index";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.documentos = res.documentos;
        });
    }
  },

   mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.$API
      .get({
        url: "documentos/index"
      }).then((res) => {
        this.documentos = res.documentos;
      });
  },
};
</script>
